const STRING_TYPE = 'string';
const NUMBER_TYPE = 'number';
const OBJECT_TYPE = 'obejct';
const ARRAY_TYPE = 'array';
const NULL_TYPE = 'null';
const UNDEFINED_TYPE = 'undefined';

export const CollaboratorModel = ({
  id = 0,
  firstName = '',
  lastName = '',
  email = '',
  image = null,
  userName = '',
  canSendEmail = false,
}) => {
  return {
    id,
    firstName,
    lastName,
    email,
    image,
    userName,
    canSendEmail,
  }
}

export const CollaboratorSerializer = ({
  id = 0,
  firstName = '-',
  lastName = '-',
  mail = '-',
  imageStorage = null,
  name = '- -',
  canSendEmail = false,
}) => {

  if (id === null || id === undefined) {
    console.error(TypeError(_erroTypetemplate('id', STRING_TYPE)))
    return
  }
  if (id === '') {
    console.warn(Error(_erroTypetemplate('id', STRING_TYPE)))
  }

  if (firstName === null || firstName === undefined) {
    console.error(TypeError(_erroTypetemplate('firstName', STRING_TYPE)))
    return
  }
  if (lastName === null || lastName === undefined) {
    console.error(TypeError(_erroTypetemplate('lastName', STRING_TYPE)))
    return
  }
  if (mail === null || mail === undefined) {
    console.error(TypeError(_erroTypetemplate('mail', STRING_TYPE)))
    return
  }
  if (name === null || name === undefined) {
    console.error(TypeError(_erroTypetemplate('name', STRING_TYPE)))
    return
  }

  const avatarImage = imageStorage === null ? null : imageStorage.miniObjUrl

  return CollaboratorModel({
    id,
    firstName,
    lastName,
    email: mail,
    image: avatarImage,
    userName: name,
    canSendEmail,
  });
}

export const CollaboratorListParser = ({ data = [], total = 0 }) => {
  if (data === null || data === undefined) {
    console.error(TypeError(_erroTypetemplate('data', `${NULL_TYPE} or ${UNDEFINED_TYPE}`)))
    return
  }
  if (!Array.isArray(data)) {
    console.error(TypeError('data type is not an array type'))
    return
  }

  const parsedCollaborators = data.map((e) => CollaboratorSerializer(e));

  return {
    "data": parsedCollaborators,
    "total": total,
  };
}

export function createCollaboratorAdapter({ firstName = "", lastName = "", email = "", sendEmail = true, image = null } = {}) {
  const string = 'string'
  if (
    typeof firstName !== string ||
    typeof lastName !== string ||
    typeof email !== string
  ) {
    console.warn(TypeError('some element type is not an String type'))
  }

  const obj = {
    firstName,
    lastName,
    email,
    sendEmail,
    image,
  }

  return {
    immutable: Object.freeze(obj),
    mutable: { ...obj },
  }
}


export function editCollaboratorAdapter({ firstName = "", lastName = "", email = "", image = null } = {}) {
  const string = 'string'
  if (
    typeof firstName !== string ||
    typeof lastName !== string ||
    typeof email !== string
  ) {
    console.warn(TypeError('some element type is not an String type'))
  }

  if (image === null) {
    const obj = {
      firstName,
      lastName,
      email,
    }
    return {
      immutable: Object.freeze(obj),
      mutable: { ...obj },
    }
  }

  const obj = {
    firstName,
    lastName,
    email,
    image,
  }
  return {
    immutable: Object.freeze(obj),
    mutable: { ...obj },
  }
}



/** @param {Array.<Number>} ids - and array of ids */
export function sendCollaboratorIdsAdapter(ids) {
  if (!Array.isArray(ids)) {
    console.error(Error('ids type is not an array'))
    return null
  }

  if (ids.some((el) => !Number.isInteger(el))) {
    console.warn(TypeError("some id is not an integer"))
    const integerIds = ids.filter((el) => Number.isInteger(el));

    return Object.freeze({
      "ids": integerIds
    });
  }

  return Object.freeze({
    "ids": ids
  });
}


export const onResponseDeleteCollaboratorAdapter = ({ found, success, skipped, failed, }) =>
  Object.freeze({
    found,
    success,
    skipped,
    failed,
  })


export const onDeleteResponse = {
  "found": 2,
  "success": 2,
  "skipped": 0,
  "failed": 0
}

const _erroTypetemplate = (variableName = 'fallback', variableType = 'fallback') => `${variableName} type is not a ${variableType} type`;
const _warningTypetemplate = (variableName = 'fallback', warningMessage = 'fallback') => `${variableName} value is not a ${variableType} type`;